import React, { useEffect, useMemo, useRef, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import _ from "lodash";
import DatePicker from "react-datepicker";
import SignaturePad from "react-signature-canvas";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import CustomDatePickerInput from "../_common/CustomDatePickerInput";
import { validateEmail } from "../../_utils/generalUtils";
import AlertModal from "../_common/AlertModal";
import AlertBox from "../_common/AlertBox";

// BELOW ONLY FOR MULTIPLE CONTRACTOR OPTION:
// import Select from "react-select";
// import { getContractorOption } from "./utils/adrUtilsV3";

function AdrTentativeAgreementContractorSignModalV3(props) {
  const {
    projectId,
    showModal,
    toggleModal,
    forCustomTa,
    contractorsClient,
    applySignatures,
  } = props;

  const projContractorList = useSelector(
    (state) => state.contractors.projContractorLists[projectId] || null
  );

  const hasPrevSignature = useMemo(
    () => Object.values(contractorsClient).some((cc) => cc.contractorRepSignedOn),
    [contractorsClient]
  );

  const [formErrors, setFormErrors] = useState({ name: null, date: null, email: null });

  const [showAlert_signatureEmpty, _setShowAlert_signatureEmpty] = useState(false);
  const toggleAlert_signatureEmpty = () =>
    _setShowAlert_signatureEmpty(!showAlert_signatureEmpty);

  const [showAlert_formIncomplete, _setShowAlert_formIncomplete] = useState(false);
  const toggleAlert_formIncomplete = () =>
    _setShowAlert_formIncomplete(!showAlert_formIncomplete);

  const [showAlert_disputeConfirm, _setShowAlert_disputeConfirm] = useState(false);
  const toggleAlert_disputeConfirm = () =>
    _setShowAlert_disputeConfirm(!showAlert_disputeConfirm);

  const [showAlert_deleteSignatureConfirm, _setShowAlert_deleteSignatureConfirm] =
    useState(false);
  const toggleAlert_deleteSignatureConfirm = () =>
    _setShowAlert_deleteSignatureConfirm(!showAlert_deleteSignatureConfirm);

  const fieldsToValidate = useRef([
    "contractorRepSignedOn",
    "contractorRepName",
    "contractorRepEmail",
  ]);

  // BELOW ONLY FOR MULTIPLE CONTRACTOR OPTION:
  // const contractorOptions = projContractorList
  //   ? projContractorList
  //       .filter((pc) =>
  //         Object.keys(contractorsClient)
  //           .map((cId) => +cId)
  //           .includes(pc.contractorId)
  //       )
  //       .map((pc) => getContractorOption(pc))
  //   : [];

  // BELOW ONLY FOR MULTIPLE CONTRACTOR OPTION:
  // const [selectedContractor, setContractor] = useState(
  //   Object.keys(contractorsClient).length > 0
  //     ? contractorOptions.find(
  //         (co) =>
  //           co.value === contractorsClient[Object.keys(contractorsClient)[0]].contractorId
  //       ) || null
  //     : null
  // );

  // BELOW ONLY FOR SINGLE CONTRACTOR OPTION:
  const [selectedContractor, setContractor] = useState(
    Object.keys(contractorsClient).length > 0
      ? (projContractorList || []).find(
          (c) =>
            c.contractorId ===
            contractorsClient[Object.keys(contractorsClient)[0]].contractorId
        ) || null
      : null
  );
  const [contractorRepFields, _setContractorRepFields] = useState(
    _.cloneDeep(contractorsClient)
  );

  // BELOW ONLY FOR MULTIPLE CONTRACTOR OPTION:
  // useEffect(() => {
  //   const taContractor = contractorRepFields[selectedContractor.contractorId] || null;
  //   if (taContractor)
  //     setContractorRepFields({
  //       contractorRepSignature: taContractor.contractorRepSignature,
  //       contractorRepSignedOn: taContractor.contractorRepSignedOn,
  //       contractorRepName: taContractor.contractorRepName,
  //       contractorRepRemarks: taContractor.contractorRepRemarks,
  //     });
  // }, [selectedContractor]);

  useEffect(() => validateForm(), [contractorRepFields[selectedContractor.contractorId]]);

  /** @type {React.MutableRefObject<SignaturePad>} */
  const contractorRepSignPad = useRef(null);

  const validateForm = () => {
    let _formErrors = { ...formErrors };
    const isWetSigned =
      contractorRepFields[selectedContractor.contractorId].isWetSignedByContractor;
    const contractorRepName = (
      contractorRepFields[selectedContractor.contractorId].contractorRepName || ""
    ).trim();

    fieldsToValidate.current.forEach((fieldToValidate) => {
      switch (fieldToValidate) {
        case "contractorRepName":
          // For CEM4907, if signature is accepted or drawn, require name
          // For custom form, if signedOn is populated, require name
          // For either form type, if disputed, require name
          if (
            (isWetSigned && !contractorRepName) ||
            (!isWetSigned &&
              ((!forCustomTa &&
                (contractorRepFields[selectedContractor.contractorId]
                  .contractorRepSignature ||
                  (contractorRepSignPad.current &&
                    !contractorRepSignPad.current.isEmpty())) &&
                !contractorRepName) ||
                (forCustomTa &&
                  contractorRepFields[selectedContractor.contractorId]
                    .contractorRepSignedOn &&
                  !contractorRepName)))
          )
            _formErrors = { ..._formErrors, name: "Required" };
          else _formErrors = { ..._formErrors, name: null };
          break;
        case "contractorRepSignedOn":
          if (
            (isWetSigned || forCustomTa) &&
            !contractorRepFields[selectedContractor.contractorId].contractorRepSignedOn
          )
            _formErrors = { ..._formErrors, date: "Required" };
          else _formErrors = { ..._formErrors, date: null };
          break;
        case "contractorRepEmail":
          if (
            contractorRepFields[selectedContractor.contractorId].contractorRepEmail &&
            !validateEmail(
              contractorRepFields[selectedContractor.contractorId].contractorRepEmail
            )
          )
            _formErrors = { ..._formErrors, email: "Invalid email" };
          else _formErrors = { ..._formErrors, email: null };
          break;
        default:
          break;
      }
    });

    setFormErrors(_formErrors);
  };

  const formIsIncomplete = () => Object.values(formErrors).some((e) => e);

  const setContractorRepFields = (fields) => {
    let tacs = _.cloneDeep(contractorRepFields);
    let tac = tacs[selectedContractor.contractorId];
    if (fields && typeof fields === "object" && Object.keys(fields).length > 0) {
      for (const key in fields) {
        if (key in tac) tac[key] = fields[key];
      }
    }
    _setContractorRepFields(tacs);
  };

  // BELOW ONLY FOR MULTIPLE CONTRACTOR OPTION:
  // const handleChange_contractor = (selectedContractor_new) =>
  //   setContractor(selectedContractor_new);

  const getUpdatedContractorRepFieldsWithSignature = () => {
    const isWetSigned =
      contractorRepFields[selectedContractor.contractorId].isWetSignedByContractor;

    // Create a temp store for the state
    const _contractorRepFields = _.cloneDeep(contractorRepFields);

    if (
      !forCustomTa &&
      !isWetSigned &&
      contractorRepSignPad.current &&
      !contractorRepSignPad.current.isEmpty() &&
      !contractorRepFields[selectedContractor.contractorId].contractorRepSignature
    ) {
      const ctrSigDataURL = contractorRepSignPad.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      contractorRepSignPad.current.clear();

      _contractorRepFields[selectedContractor.contractorId].contractorRepSignature =
        ctrSigDataURL;
      _contractorRepFields[selectedContractor.contractorId].contractorRepSignedOn =
        Date.now();
    }

    _contractorRepFields[selectedContractor.contractorId].isDisputedByContractor = false;

    return _contractorRepFields;
  };

  const handleClick_ok = (e) => {
    e.preventDefault();

    const isWetSigned =
      contractorRepFields[selectedContractor.contractorId].isWetSignedByContractor;

    // Alert if user pressed OK without signing
    if (
      (!forCustomTa &&
        !isWetSigned &&
        contractorRepSignPad.current &&
        contractorRepSignPad.current.isEmpty()) ||
      (forCustomTa &&
        !contractorRepFields[selectedContractor.contractorId].contractorRepSignedOn)
    ) {
      toggleAlert_signatureEmpty();
    } else if (formIsIncomplete()) {
      toggleAlert_formIncomplete();
    } else {
      // For CEM4907, if signature is drawn but not accepted, accept it programmatically
      const _contractorRepFields = getUpdatedContractorRepFieldsWithSignature();
      applySignatures(_contractorRepFields);
      toggleModal();
    }
  };

  const handleChange = (e) => setContractorRepFields({ [e.target.name]: e.target.value });

  const handleBlur = () => validateForm();

  // const handleChange = ctrId => e => updateContractorRepFields(ctrId, {[e.target.name]: e.target.value});
  const handleClick_clearContractorRepSign = (e) => {
    e.preventDefault();
    setContractorRepFields({
      contractorRepSignature: "",
      contractorRepSignedOn: null,
    });
    contractorRepSignPad.current.clear();
  };

  const handleChange_date = (value) =>
    setContractorRepFields({ contractorRepSignedOn: value });

  const handleClick_clearContractorRepSign_img = (e) => {
    e.preventDefault();
    setContractorRepFields({
      contractorRepSignature: "",
      contractorRepSignedOn: null,
    });
  };

  const handleClick_acceptContractorRepSign = (e) => {
    e.preventDefault();
    if (!contractorRepSignPad.current.isEmpty()) {
      const _contractorRepFields = getUpdatedContractorRepFieldsWithSignature();
      _setContractorRepFields(_contractorRepFields);
    }
  };

  const handleAlert_signatureEmpty = (actionType) => (e) => {
    e.preventDefault();
    if (actionType === "accept") {
      applySignatures(contractorRepFields);
      toggleAlert_signatureEmpty();
      toggleModal();
    }
    toggleAlert_signatureEmpty();
  };

  const handleAlert_deleteSignatureConfirm = (actionType) => (e) => {
    e.preventDefault();
    if (actionType === "accept") {
      applySignatures(
        {
          ...contractorRepFields,
          [selectedContractor.contractorId]: {
            ...contractorRepFields[selectedContractor.contractorId],
            contractorRepSignature: "",
            contractorRepSignedOn: null,
            contractorRepName: "",
            contractorRepRemarks: "",
            contractorRepEmail: "",
            isDisputedByContractor: false,
          },
        },
        selectedContractor.contractorId
      );
      toggleAlert_deleteSignatureConfirm();
      toggleModal();
    }
    toggleAlert_deleteSignatureConfirm();
  };

  const handleClick_delete = (e) => {
    e.preventDefault();
    // No need to upate the state since we're exiting the modal.
    toggleAlert_deleteSignatureConfirm();
  };

  const closeBtn = (
    <button className="close" onClick={toggleModal}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <Modal isOpen={showModal} size="md">
      <ModalHeader className="bg-info text-white" close={closeBtn}>
        <FontAwesomeIcon icon="file-signature" className="fa-fw mr-2" />
        Sign Tentative Agreement
      </ModalHeader>
      <ModalBody>
        {/* <div className="card mb-2">
          <div className="card-body bg-lightgray">
            <div className="form-row form-group mb-0">
              <label className="col-sm-3 col-form-label">
                <strong>Contractor:</strong>
              </label>
              <div className="col-sm-6 my-auto">
                <Select
                  name="contractorId"
                  id="taSignContractorSelect"
                  value={selectedContractor}
                  options={contractorOptions}
                  onChange={handleChange_contractor}
                  placeholder="(Select a Contractor)"
                />
              </div>
            </div>
          </div>
        </div> */}
        <div className="card">
          <div className="card-body p-3">
            <h6 className="text-muted mb-0">Contractor Representative For:</h6>
            <h5>{selectedContractor ? selectedContractor.name : ""}</h5>
            {forCustomTa && (
              <AlertBox icon="exclamation-triangle" color="warning" className="mb-2">
                Please sign the original copy before proceeding with below.
              </AlertBox>
            )}
            {!forCustomTa && (
              <React.Fragment>
                <div className="form-row">
                  <div className="col">
                    <span>
                      <b>Signature:</b>
                    </span>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-12">
                    <div className="form-check-inline custom-control custom-radio mt-1 ml-2">
                      <div className="radio">
                        <input
                          type="radio"
                          name="isWetSignedByContractor"
                          id="isWetSignedByContractor"
                          checked={
                            contractorRepFields[selectedContractor.contractorId]
                              .isWetSignedByContractor
                          }
                          onChange={(e) =>
                            e.target.checked &&
                            setContractorRepFields({
                              isWetSignedByContractor: true,
                              contractorRepSignature: "",
                              contractorRepSignedOn: null,
                            })
                          }
                          className="custom-control-input"
                          disabled={hasPrevSignature}
                        />
                        <label
                          htmlFor="isWetSignedByContractor"
                          className="custom-control-label my-auto"
                        >
                          Signed elsewhere (e.g. wet signature on hard copy)
                        </label>
                      </div>
                    </div>
                    <div className="form-check-inline custom-control custom-radio mt-1 ml-2">
                      <div className="radio">
                        <input
                          type="radio"
                          name="signUsingThisDevice"
                          id="signUsingThisDevice"
                          checked={
                            !contractorRepFields[selectedContractor.contractorId]
                              .isWetSignedByContractor
                          }
                          onChange={(e) =>
                            e.target.checked &&
                            setContractorRepFields({
                              isWetSignedByContractor: false,
                              contractorRepSignedOn: null,
                            })
                          }
                          className="custom-control-input"
                          disabled={hasPrevSignature}
                        />
                        <label
                          htmlFor="signUsingThisDevice"
                          className="custom-control-label my-auto"
                        >
                          Sign using this device (draw below):
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col">
                    <div className="ta-sign__signpad">
                      {contractorRepFields[selectedContractor.contractorId]
                        .isWetSignedByContractor ? (
                        <div className="m-2 text-small">
                          Provide the date of signature in "Signed On" field below, and
                          attach a photo/scan of the signed copy.
                        </div>
                      ) : contractorRepFields[selectedContractor.contractorId]
                          .contractorRepSignature ? (
                        <React.Fragment>
                          <img
                            src={
                              contractorRepFields[selectedContractor.contractorId]
                                .contractorRepSignature
                            }
                            alt="Contractor Rep Signature"
                            style={{ width: "100%", height: "100%" }}
                          />
                          {!hasPrevSignature && (
                            <div className="ta-sign__signpad__controls">
                              <button
                                id="clearContractorRepSign"
                                name="clearContractorRepSign"
                                className="btn btn-sm btn-secondary mr-2"
                                onClick={handleClick_clearContractorRepSign_img}
                                onTouchEnd={handleClick_clearContractorRepSign_img}
                              >
                                Clear
                              </button>
                            </div>
                          )}
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <SignaturePad
                            canvasProps={{ style: { width: "100%", height: "100%" } }}
                            ref={(ref) => {
                              contractorRepSignPad.current = ref;
                            }}
                            onEnd={validateForm}
                          />
                          <div className="ta-sign__signpad__controls">
                            <button
                              id="clearContractorRepSign"
                              name="clearContractorRepSign"
                              className="btn btn-sm btn-outline-secondary mr-2"
                              onClick={handleClick_clearContractorRepSign}
                              onTouchEnd={handleClick_clearContractorRepSign}
                            >
                              Clear
                            </button>
                            <button
                              id="clearContractorRepSign"
                              name="clearContractorRepSign"
                              className="btn btn-sm btn-success"
                              onClick={handleClick_acceptContractorRepSign}
                              onTouchEnd={handleClick_acceptContractorRepSign}
                            >
                              Accept
                            </button>
                          </div>
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                </div>
              </React.Fragment>
            )}
            <div className="form-row form-group mb-2">
              <label htmlFor="contractorRepSignedOn" className="col-form-label col-3">
                <b>Signed On:</b>
              </label>
              <div className="col-9">
                {!forCustomTa &&
                !contractorRepFields[selectedContractor.contractorId]
                  .isWetSignedByContractor ? (
                  <input
                    name="contractorRepSignedOn"
                    id="contractorRepSignedOn"
                    className="form-control"
                    value={
                      contractorRepFields[selectedContractor.contractorId]
                        .contractorRepSignedOn
                        ? new Date(
                            contractorRepFields[
                              selectedContractor.contractorId
                            ].contractorRepSignedOn
                          ).toLocaleString()
                        : ""
                    }
                    onChange={() => {}}
                    disabled={true}
                  />
                ) : (
                  <>
                    <DatePicker
                      customInput={<CustomDatePickerInput />}
                      name="reportStartDate"
                      id="reportStartDate"
                      selected={
                        contractorRepFields[selectedContractor.contractorId]
                          .contractorRepSignedOn
                          ? new Date(
                              contractorRepFields[
                                selectedContractor.contractorId
                              ].contractorRepSignedOn
                            )
                          : null
                      }
                      dateFormat="MM/dd/yyyy (E)"
                      onChange={handleChange_date}
                      disabled={hasPrevSignature}
                    />
                    {formErrors.date && (
                      <span className="error-small">
                        <small>{formErrors.date}</small>
                      </span>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="form-row form-group my-2">
              <label htmlFor="contractorRepName" className="col-form-label col-3">
                <b>Name:</b>
              </label>
              <div className="col-9">
                <input
                  id="contractorRepName"
                  name="contractorRepName"
                  className="form-control"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={
                    contractorRepFields[selectedContractor.contractorId].contractorRepName
                  }
                  disabled={hasPrevSignature}
                />
                {formErrors.name && (
                  <span className="error-small">
                    <small>{formErrors.name}</small>
                  </span>
                )}
              </div>
            </div>
            <div className="form-row form-group mb-2">
              <label htmlFor="contractorRepRemarks" className="col-form-label col-3">
                Remarks:
              </label>
              <div className="col-9">
                <input
                  id="contractorRepRemarks"
                  name="contractorRepRemarks"
                  maxLength={30}
                  className="form-control"
                  onChange={handleChange}
                  onBlur={handleChange}
                  value={
                    contractorRepFields[selectedContractor.contractorId]
                      .contractorRepRemarks
                  }
                />
                <span className="text-small">
                  {`${
                    (
                      contractorRepFields[selectedContractor.contractorId]
                        .contractorRepRemarks || ""
                    ).length
                  }/30 characters`}
                </span>
              </div>
            </div>
            <div className="form-row form-group mb-0">
              <label htmlFor="contractorRepEmail" className="col-form-label col-3">
                Email:
              </label>
              <div className="col-9">
                <input
                  id="contractorRepEmail"
                  name="contractorRepEmail"
                  className="form-control"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={
                    contractorRepFields[selectedContractor.contractorId]
                      .contractorRepEmail
                  }
                />
                {formErrors.email && (
                  <span className="error-small">
                    <small>{formErrors.email}</small>
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="bg-lightgray">
        <div className="form-row form-group">
          {hasPrevSignature && (
            <>
              <button
                id="taSignDelete"
                name="taSignDelete"
                className="btn btn-danger mr-2"
                onClick={handleClick_delete}
              >
                <FontAwesomeIcon icon="trash-alt" className="fa-fw mr-1" />
                Delete Signature
              </button>
              <span className="my-auto">|</span>
            </>
          )}
          <button
            id="taSignCancel"
            name="taSignCancel"
            className="btn btn-secondary mx-2"
            onClick={toggleModal}
          >
            Cancel
          </button>
          <button
            id="taSignOk"
            name="taSignOk"
            className="btn btn-primary"
            onClick={handleClick_ok}
          >
            OK
          </button>
        </div>
      </ModalFooter>
      {showAlert_signatureEmpty && (
        <AlertModal
          alertKey={"taSignatureEmptyAlert"}
          alertTitle={"Signature Incomplete"}
          alertTitleClass="bg-warning"
          alertTitleIcon="exclamation-triangle"
          alertText="There is no signature. Do you wish to exit?"
          acceptCaption={"Yes"}
          acceptClass={"danger"}
          provideReject={true}
          rejectCaption={"No"}
          rejectClass={"secondary"}
          handleAlertAction={handleAlert_signatureEmpty}
          showAlertModal={showAlert_signatureEmpty}
          toggleAlertModal={toggleAlert_signatureEmpty}
        />
      )}
      {showAlert_formIncomplete && (
        <AlertModal
          alertKey="taFormIncompleteAlert"
          alertTitle="Form Incomplete"
          alertTitleClass="bg-warning"
          alertTitleIcon="exclamation-triangle"
          alertText="Not all required fields are complete."
          acceptCaption={"OK"}
          acceptClass={"secondary"}
          provideReject={false}
          handleAlertAction={toggleAlert_formIncomplete}
          showAlertModal={showAlert_formIncomplete}
          toggleAlertModal={toggleAlert_formIncomplete}
        />
      )}
      {showAlert_deleteSignatureConfirm && (
        <AlertModal
          alertKey={"taDeleteSignatureConfirm"}
          alertTitle={"Delete Signature"}
          alertTitleClass="bg-warning"
          alertTitleIcon="exclamation-triangle"
          alertText="Are you sure you wish to delete this signature?"
          acceptCaption={"Yes"}
          acceptClass={"danger"}
          provideReject={true}
          rejectCaption={"No"}
          rejectClass={"secondary"}
          handleAlertAction={handleAlert_deleteSignatureConfirm}
          showAlertModal={showAlert_deleteSignatureConfirm}
          toggleAlertModal={toggleAlert_deleteSignatureConfirm}
        />
      )}
    </Modal>
  );
}

export default AdrTentativeAgreementContractorSignModalV3;
